import { gql, useMutation } from "@apollo/client";

const UPDATE_COURSE_VISIBILITY_MUTATION = gql`
  mutation updateCourseVisibility($courseId: ID!, $clinicIds: [ID!]!) {
    updateCourseVisibility(courseId: $courseId, clinicIds: $clinicIds) {
      id
      visibleToClinics {
        id
        name
      }
    }
  }
`;

interface UpdateCourseVisibilityVariables {
  courseId: string;
  clinicIds: string[];
}

interface UpdateCourseVisibilityResponse {
  updateCourseVisibility: {
    id: string;
    visibleToClinics: {
      id: string;
      name: string;
    }[];
  };
}

export function useUpdateCourseVisibility() {
  return useMutation<UpdateCourseVisibilityResponse, UpdateCourseVisibilityVariables>(
    UPDATE_COURSE_VISIBILITY_MUTATION,
    {
      refetchQueries: ["courses", "allCourses"],
    },
  );
}
